export const CoreInitiativesBulkName = 'CoreInitiativesBulk';
